export const getToken = () => localStorage.getItem("token");

export const getRole = () => localStorage.getItem("role");

export const getIsSubscribed = (): boolean => {
  const v = localStorage.getItem("isSubscribed");
  return v === "true";
};

export const saveAuth = (token: string, role: string, isSubscribed?: boolean) => {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  if (isSubscribed !== undefined) {
    localStorage.setItem("isSubscribed", String(isSubscribed));
  }
};

export const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("isSubscribed");
};
